import Icon from '../../../se/components/Icon';
import React from 'react';
import RouterLink from '../../../se/components/RouterLink';
import styled from 'styled-components';
import responsive, { breakpoint } from '../../../se/utilities/responsive';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Link } from 'react-router-dom';
import { ArrowBack } from '@material-ui/icons';

const VerticalContainer = styled.div`
  display: flex;
  flex-direction: column;
  > :first-child {
    margin-bottom: 0.5em;
  }
  ${responsive.md.andSmaller`
    margin-top: 1em;
    width: 100%;
  `}
`;

const BackButton = ({ name, pathname, location }) => (
  <RouterLink to={{ pathname, search: location.search }}>
    <ArrowBack fontSize={'small'} />
    &nbsp;{name}
  </RouterLink>
);

const TabNavigation = ({ tabs, location }) => {
  const current = tabs.find(tab => tab.pathname === location.pathname) || {};
  const alertPage = tabs.find(_ => _.id === 'alert');
  const isMobile = window.innerWidth < breakpoint.md;

  return (
    <VerticalContainer>
      {current.name ? <label>{current.name}</label> : <BackButton {...alertPage} location={location} />}
      <Tabs indicatorColor={'primary'} value={location.pathname} orientation={isMobile ? 'vertical' : 'horizontal'}>
        {tabs.map(({ id, pathname, icon, name }) => (
          <Tab
            key={id}
            component={Link}
            to={{ pathname: pathname, search: location.search }}
            icon={icon ? <Icon>{icon}</Icon> : false}
            value={pathname}
            label={name}
          />
        ))}
      </Tabs>
    </VerticalContainer>
  );
};

export default TabNavigation;
